// NPM Imports
import React, { Fragment } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Toastr } from "../../revvComponents";

// component Imports
import PlanChangeRequest from "../SettingsWrapper/BillingSettings/PlanChangeRequest";
import SeeAllPlansPopup from "../../commonComponents/SeeAllPlansPopup";
import BillingBandLeftDaysSection from "./BillingBandLeftDaysSection";
import TrialEndBandSection from "./TrialEndBandSection";
import RecurringInfoBand from "./RecurringInfoBand";
// Action Imports
import { SettingsActions } from "../../actions";
import { getCustomerPortalURL } from "../../actions/SettingsActions/settingsActions";
import { GlobalUtils } from "../../utils";

// Destructuring
const { getBillingInformation } = SettingsActions;
const { readDataFromLocalStorage } = GlobalUtils;
const BILLING_BAND_CANCEL_DAYS_POSSIBILITY = 2;
const BILLING_BAND_SHOW_START_DAYS = 5;
const BILLING_BAND_SHOW_END_DATE = 1;

class BillingBandInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showBillingBand: false,
      showDayLeftBand: false,
      showContactUsBand: false,
      daysLeft: 0,
      planId: "",
      contactUsPopup: false,
      planSubscribeRequestPopup: false,
    };
  }

  componentDidMount() {
    this.props
      .getBillingInformation()
      .then(() => {
        this._decideView();
      })
      .catch(err =>
        console.error(
          "BillingBandInfo => CMD => Failed to fetcg billing info",
          err,
        ),
      );
  }

  _decideView = () => {
    const { billingInfo } = this.props;
    if (
      billingInfo.subscription &&
      billingInfo.subscription.status === "in_trial" &&
      !billingInfo.payment_source.last_four_digit
    ) {
      this.setState({
        planId: billingInfo.subscription.plan_id,
        showBillingBand: true,
        showDayLeftBand: true,
        daysLeft: this._showPlanDayLeft(billingInfo.subscription.trial_end),
      });
    } else if (
      billingInfo.subscription &&
      billingInfo.auto_downgraded === true &&
      !billingInfo.payment_source.last_four_digit
    ) {
      this.setState({
        planId: billingInfo.subscription.plan_id,
        showBillingBand: true,
        showContactUsBand: true,
        showDayLeftBand: false,
        daysLeft: 0,
      });
    } else {
      this.setState({
        planId: "",
        showBillingBand: false,
        showContactUsBand: false,
        showDayLeftBand: false,
        daysLeft: 0,
      });
    }
  };

  _hideBillingBand = () => {
    this.setState({
      showBillingBand: false,
    });
  };

  _updateBilling = () => {
    // this.props
    //   .getSubscriptionCheckoutSessionID(
    //     this.props.billingInfo.subscription.plan_id,
    //   )
    //   .then(() => {})
    //   .catch(error => {
    //     this.props.onClose();
    //     Toastr.showToastr({
    //       type: "failure",
    //       message: handleApiErrMsg(error),
    //       timeout: 3000,
    //     });
    //   });
    this.props.getCustomerPortalURL().catch(() => {
      this.props.onClose();
      Toastr.showToastr({
        type: "failure",
        message: "Oops, Something went wrong!!",
        timeout: 3000,
      });
    });
  };

  _showPlanDayLeft = value => {
    const planEnd = moment.unix(value);
    const current = moment();
    const planEndDate = moment(planEnd, "DD-MM-YYYY");
    const currentDate = moment(current, "DD-MM-YYYY");
    return planEndDate.diff(currentDate, "days") + 1;
  };

  _actionOnTextClick = async () => {
    this.setState({
      planSubscribeRequestPopup: true,
    });
  };

  _closePopUp = incomingPopupState => {
    this.setState({
      [incomingPopupState]: false,
    });
  };

  _getMainMessage = () => {
    const { showDayLeftBand, daysLeft, showContactUsBand } = this.state;
    let message = "";
    if (showDayLeftBand && daysLeft <= BILLING_BAND_SHOW_START_DAYS) {
      if (daysLeft === BILLING_BAND_SHOW_END_DATE) {
        message = `Your trial is about to expire in a day. ${" "}`;
      } else {
        message = `Your trial is about to expire in ${daysLeft} days. ${" "}`;
      }
    } else if (!showDayLeftBand && showContactUsBand) {
      message = `Your free trial for the Premium plan has expired. ${" "}`;
    }
    return message;
  };

  _getSecondaryMessage = () => {
    const { showDayLeftBand, daysLeft, showContactUsBand } = this.state;
    let secondaryMessage = "";
    if (showDayLeftBand && daysLeft <= BILLING_BAND_SHOW_START_DAYS) {
      secondaryMessage = "Subscribe now to continue using Premium features.";
    } else if (!showDayLeftBand && showContactUsBand) {
      secondaryMessage = "Upgrade now to access the premium features in Revv. ";
    }
    return secondaryMessage;
  };

  render() {
    const revvPlanStatus = readDataFromLocalStorage("revv_planStatus");
    const {
      showBillingBand,
      daysLeft,
      planId,
      contactUsPopup,
      showDayLeftBand,
      showContactUsBand,
      planSubscribeRequestPopup,
    } = this.state;
    return (
      <Fragment>
        {revvPlanStatus === "grace" && (
          <RecurringInfoBand updateBilling={this._updateBilling} />
        )}
        {contactUsPopup && planId && (
          <PlanChangeRequest
            currentPlan={planId}
            onClose={() => this._closePopUp("contactUsPopup")}
          />
        )}
        {planSubscribeRequestPopup && (
          <SeeAllPlansPopup
            onClose={() => this._closePopUp("planSubscribeRequestPopup")}
          />
        )}
        {showBillingBand && showDayLeftBand && !showContactUsBand && (
          <BillingBandLeftDaysSection
            mainMessage={this._getMainMessage()}
            secondaryMessage={this._getSecondaryMessage()}
            actionOnTextClick={this._actionOnTextClick}
            daysLeft={daysLeft}
            showStartDate={BILLING_BAND_SHOW_START_DAYS}
            cancleButtonVisibility={BILLING_BAND_CANCEL_DAYS_POSSIBILITY}
            hideBillingBand={this._hideBillingBand}
          />
        )}
        {showBillingBand && !showDayLeftBand && showContactUsBand && (
          <TrialEndBandSection
            mainMessage={this._getMainMessage()}
            secondaryMessage={this._getSecondaryMessage()}
            actionOnTextClick={this._actionOnTextClick}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { billingInfo } = state.CommonStore;

  return { billingInfo };
};

const mapDispatchToProps = {
  getBillingInformation,
  getCustomerPortalURL,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(BillingBandInfo));
